import FileResizer from 'react-image-file-resizer';

export type ResizeOptions = {
  maxWidth: number;
  maxHeight: number;
  format?: 'JPEG' | 'PNG' | 'WEBP';
  quality?: number; // 0-100
  rotation?: number;
  outputType?: 'base64' | 'file' | 'blob';
};

const defaultOptions: Required<
  Pick<ResizeOptions, 'format' | 'quality' | 'rotation' | 'outputType'>
> &
  Pick<ResizeOptions, 'maxWidth' | 'maxHeight'> = {
  maxWidth: 1500,
  maxHeight: 2655,
  format: 'JPEG',
  quality: 90,
  rotation: 0,
  outputType: 'base64'
};

export async function resizeImageFile(
  file: File,
  options?: Partial<ResizeOptions>
): Promise<string | File | Blob> {
  const cfg = { ...defaultOptions, ...(options || {}) };
  return new Promise((resolve) => {
    FileResizer.imageFileResizer(
      file,
      cfg.maxWidth,
      cfg.maxHeight,
      cfg.format,
      cfg.quality,
      cfg.rotation,
      (uri) => resolve(uri as string | File | Blob),
      cfg.outputType
    );
  });
}

export const resizeToBase64 = (file: File): Promise<string> =>
  resizeImageFile(file, { outputType: 'base64' }) as Promise<string>;
